import parse from "html-react-parser";
import {
    healthSectionEyebrow,
    healthSectionHeaderBlock,
    healthSectionHeaderContentGap,
    healthSectionHeading,
    healthSectionSubtitle,
    healthSectionSubtitleWide,
    healthSectionTitleBlockGap,
} from "./healthVisualStyles";

interface HealthSectionHeaderProps {
    title: string;
    titleId?: string;
    eyebrow?: string;
    subtitle?: string;
    /** Use wider subtitle max-width (e.g. Problem, Ecosystem intros). */
    subtitleWide?: boolean;
    className?: string;
}

export function HealthSectionHeader({
    title,
    titleId,
    eyebrow,
    subtitle,
    subtitleWide = false,
    className = "",
}: HealthSectionHeaderProps) {
    const subtitleClass = subtitleWide
        ? healthSectionSubtitleWide
        : healthSectionSubtitle;

    return (
        <header
            className={`${healthSectionHeaderBlock} ${className}`.trim()}
        >
            <div className={healthSectionHeaderContentGap}>
                {eyebrow ? (
                    <p className={healthSectionEyebrow}>{eyebrow}</p>
                ) : null}
                <div className={healthSectionTitleBlockGap}>
                    <h2
                        id={titleId}
                        className={`${healthSectionHeading} whitespace-pre-line`}
                    >
                        {title}
                    </h2>
                    {subtitle ? (
                        <p className={`${subtitleClass} whitespace-pre-line`}>
                            {parse(subtitle)}
                        </p>
                    ) : null}
                </div>
            </div>
        </header>
    );
}
